import { Request } from "./request";
import { API_PREFIX } from "./constant";

export interface DoctorAchievementParams {
//   drugType?: number;
  timeHead?: string;
  timeTail?: string;
}

export function getDoctorAchievement(
  params: DoctorAchievementParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorPerformanceList`,
    method: "GET",
    params,
  };
}

export function getDoctorAchievementExport(
  params: DoctorAchievementParams
): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/statistics/doctorPerformanceList/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

// 业绩详情导出
export function getDoctorAchievementDetailExport(
  params: DoctorAchievementDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-report/statistics/doctorAchievementDetail/exportexcel`,
    method: 'GET',
    responseType: 'blob',
    params,
  }
}

export interface DoctorAchievementDetailParams {
  patientName?: any;
  doctorId?: any;
  recordType?: any;
  current?: any;
  size?: any;
  timeHead?: string;
  timeTail?: string;
}

export function getDoctorAchievementDetail(
  params: DoctorAchievementDetailParams
): Request {
  return {
    url: `${API_PREFIX}/blade-report/statistics/doctorAchievementDetail`,
    method: "GET",
    params,
  };
}
